import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { UserAuthenticationService } from '../../../../../../libs/administration/src/lib/services/user-authentication.service';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
class AdminGuardService {
  constructor(
    private _router: Router,
    private _authService: UserAuthenticationService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this._authService.isAdmin()) {
      return true;
    } else {
      this._router.navigate(['welcome']);
      return true;
    }
  }
}

export const AdminGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(AdminGuardService).canActivate(next, state);
};
